import { trackAddToCart } from './metaPixel'

export const CHECKOUT_URL = 'https://tuversionelevada.com/cart/53233568842025:1'

export function goToCheckout() {
  trackAddToCart({
    value: 6.39,
    currency: 'USD',
    content_name: 'Chakra Reset: 7 Días de Desbloqueo',
  })
  window.location.href = CHECKOUT_URL
}
